import React from 'react';
import _ from '@dh-fe/translate';
import FormattedMoney from 'components/FormattedMoney/FormattedMoney';
import Icon1kOranum from './assets/Icon1kOranum.svg';
import Icon3kOranum from './assets/Icon3kOranum.svg';
import Icon5kOranum from './assets/Icon5kOranum.svg';
import Icon10kOranum from './assets/Icon10kOranum.svg';

export const getTitle = () => _`Top Experts Contest`;

export const getSubtitle = () => _`Rise in the rankings and win cash prizes!`;

const placesOranum = {
    first: {
        place: '1st Place',
        award: _`[b]{amount}[/b]`.parseBB().toJSX({ amount: <FormattedMoney amount={1_000} currency="usd" /> }),
        icon: Icon10kOranum,
    },
    second: {
        place: '2nd Place',
        award: _`[b]{amount}[/b]`.parseBB().toJSX({ amount: <FormattedMoney amount={750} currency="usd" /> }),
        icon: Icon5kOranum,
    },
    third: {
        place: '3rd Place',
        award: _`[b]{amount}[/b]`.parseBB().toJSX({ amount: <FormattedMoney amount={500} currency="usd" /> }),
        icon: Icon3kOranum,
    },
    fourth: {
        place: '10 random giveaways',
        award: _`[b]{amount}[/b]*`
            .parseBB()
            .toJSX({ amount: <FormattedMoney amount={250} currency="usd" key={250} /> }),
        icon: Icon1kOranum,
    },
};

export const getPrizes = (): typeof placesOranum => placesOranum;

export const getGiftCard = () => {
    return _`*Must have a min. of {hours} hours online and {earning} in earnings.`
        .withData({ hours: 60 })
        .toJSX({ earning: <FormattedMoney amount={500} currency="usd" key={500} /> });
};

export const getParagraphs = () => {
    const oranumParagraphs = [
        _`Our newest monthly contest is here to motivate you to stay active, engage with your members, and use all the site's available features.`,
        _`Collect points through the end of the [b]month[/b] to climb to Top Experts ranking and [b]win amazing prizes![/b]`
            .parseBB()
            .toJSX(),
        _`Every dollar you make, every minute you [b]spend[/b] online, and every message you reply to bring you closer to your cash prize!`
            .parseBB()
            .toJSX(),
        _`Remember, [b]every dollar earned[/b] increases your chances to win the random prize. The more you earn, the higher probability you will win a prize!`
            .parseBB()
            .toJSX(),
    ];

    return oranumParagraphs;
};

export const getFooterText = () => {
    return _`Connect with your members and support them through thick and thin to boost your earnings, climb to the top, [b]and win![/b]`
        .parseBB()
        .toJSX();
};

export const moreInfo = _`For more info check out the Wiki Page!`;
